(function () {
  "use strict";

  actionLogResource.$inject = ['$resource', 'errorHandler'];
  angular
    .module('trainerWebApp.resources')
    .factory('actionLogResource', actionLogResource);

  function actionLogResource($resource, errorHandler) {
    var ActionLogResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/actionLog');

    ActionLogResource.prototype.writeActionLog = function writeActionLog(actionLogs, resultCb, errorCb) {
      return ActionLogResource.save({actionLogs: actionLogs}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    return new ActionLogResource;
  }

})();
